// useInaudiblePopup.js
import { useEffect, useRef, useState } from "react";

const useInaudiblePopup = ({
  audioStatus,
  activeChat,
  loadingChat,
  transcript,
}) => {
  const silenceTimer = useRef(null);
  const countdownInterval = useRef(null);

  const [countdown, setCountdown] = useState(1);
  const [showPopup, setShowPopup] = useState(false);

  const clearTimers = () => {
    clearInterval(countdownInterval.current);
  };

  const startSilenceDetection = () => {
    resetSilenceTimer();
  };

  const startCountdown = () => {
    // setCountdown(5);

    countdownInterval.current = setInterval(() => {
      setCountdown((prev) => prev + 1);
    }, 1000);
  };

  const resetSilenceTimer = () => {
    clearTimeout(silenceTimer.current);
    if (audioStatus && activeChat && !loadingChat) {
      silenceTimer.current = setTimeout(() => {
        if (transcript.trim() === "") {
          startCountdown();
          setShowPopup(true);
        }
      }, 20000);
    }
  };

  useEffect(() => {
    if (transcript.trim() !== "") {
      clearInterval(countdownInterval.current);
      setShowPopup(false);
    }
    return () => clearTimers();
  }, [transcript]);

  useEffect(() => {
    resetSilenceTimer();
    return () => clearTimeout(silenceTimer.current);
  }, [audioStatus, activeChat, loadingChat]);

  return { countdown, showPopup, setShowPopup, startSilenceDetection };
};

export default useInaudiblePopup;
